module.exports = __webpack_public_path__ + "assets/img/chren.b90b8ef3.png";